import React, { useState, useEffect } from 'react';

export default function HomePage({ setPage }) {
  const [companyName, setCompanyName] = useState('Your Company');

  useEffect(() => {
    fetch('/config.json')
      .then((res) => res.json())
      .then((data) => {
        if (data.CompanyName) {
          setCompanyName(data.CompanyName);
        }
      })
      .catch((err) => {
        console.error('Failed to load config.json:', err);
      });
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center 
                    bg-gradient-to-br from-pink-100 via-rose-50 to-teal-100 
                    overflow-hidden">

      {/* 🌸 Floating Flowers Same as Login */}
      <div className="absolute top-10 left-10 text-6xl animate-bounce opacity-20">🌸</div>
      <div className="absolute bottom-20 right-16 text-5xl animate-pulse opacity-20">🌷</div>
      <div className="absolute top-1/3 right-10 text-4xl animate-bounce opacity-20">🌺</div>

      {/* Glass Card Container */}
      <div className="backdrop-blur-lg bg-white/70 shadow-2xl 
                      rounded-3xl p-10 w-full max-w-4xl 
                      border border-white/40 transition-all duration-500">

        {/* Welcome Section */}
        <div className="text-center mb-10">
          <h1 className="text-xl uppercase tracking-widest text-gray-500 mb-2">
            Welcome to
          </h1>

          <h2 className="text-4xl sm:text-5xl font-bold text-teal-700 mb-4">
            🌼 {companyName}
          </h2>

          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover a world of flowers, plants, and natural beauty 🌿  
            Fresh blooms delivered with love and elegance.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-6 mb-12">
          <button
            onClick={() => setPage('login')}
            className="py-3 px-10 rounded-xl font-semibold text-white 
                       bg-gradient-to-r from-teal-500 to-rose-400 
                       hover:scale-105 transform transition duration-300 
                       shadow-lg"
          >
            Login 🌸
          </button>

          <button
            onClick={() => setPage('register')}
            className="py-3 px-10 rounded-xl font-semibold 
                       text-teal-700 bg-white 
                       border border-teal-300 
                       hover:scale-105 transform transition duration-300 
                       shadow-md"
          >
            Register
          </button>
        </div>

        {/* Features Section (Styled Like Glass Cards) */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">

          <div className="bg-white/60 backdrop-blur-md p-6 rounded-2xl 
                          shadow-md hover:shadow-xl transition duration-300">
            <div className="text-4xl mb-3">🌺</div>
            <h4 className="font-semibold text-lg mb-2">Fresh Quality</h4>
            <p className="text-gray-600 text-sm">
              Handpicked flowers sourced daily for maximum freshness.
            </p>
          </div>

          <div className="bg-white/60 backdrop-blur-md p-6 rounded-2xl 
                          shadow-md hover:shadow-xl transition duration-300">
            <div className="text-4xl mb-3">🚚</div>
            <h4 className="font-semibold text-lg mb-2">Fast Delivery</h4>
            <p className="text-gray-600 text-sm">
              Safe and timely delivery to your doorstep.
            </p>
          </div>

          <div className="bg-white/60 backdrop-blur-md p-6 rounded-2xl 
                          shadow-md hover:shadow-xl transition duration-300">
            <div className="text-4xl mb-3">💚</div>
            <h4 className="font-semibold text-lg mb-2">Customer Care</h4>
            <p className="text-gray-600 text-sm">
              Friendly support to help you choose the perfect plants.
            </p>
          </div>

        </div>

      </div>
    </div>
  );
}